import React, { createContext, useContext, useState } from "react";
import { defaultCutoffSearch } from "../pages/TabPages/FilterComponents/DefaultCutoffValues";

const CutoffSearchContext = createContext();
export const CutoffSearchProvider = ({ children }) => {
  //Set Initial Values
  const initialValues = defaultCutoffSearch
  const [cutoffSearchArray, setCutoffSearchArray] = useState(initialValues);

  const updateCutoffSearchArray = (values) => {
    console.log(values);
    setCutoffSearchArray(values);
  };

  return (
  <CutoffSearchContext.Provider value={{ cutoffSearchArray, updateCutoffSearchArray }}>
          {children}
  </CutoffSearchContext.Provider>
  )
};

// Custom hook to access the context
export const useCutoffSearchContext = () => useContext(CutoffSearchContext);
